import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Workbooks
export const getWorkbooks = () => api.get('/workbooks');
export const getWorkbook = (id) => api.get(`/workbooks/${id}`);
export const createWorkbook = (data) => api.post('/workbooks', data);
export const updateWorkbook = (id, data) => api.put(`/workbooks/${id}`, data);
export const deleteWorkbook = (id) => api.delete(`/workbooks/${id}`);

// Sections
export const createSection = (workbookId, data) => api.post(`/workbooks/${workbookId}/sections`, data);
export const deleteSection = (workbookId, sectionId) => api.delete(`/workbooks/${workbookId}/sections/${sectionId}`);

// Questions
export const getQuestions = (workbookId) => api.get('/questions', { params: { workbook_id: workbookId } });
export const getQuestion = (id) => api.get(`/questions/${id}`);
export const createQuestion = (data) => api.post('/questions', data);
export const updateQuestion = (id, data) => api.put(`/questions/${id}`, data);
export const deleteQuestion = (id) => api.delete(`/questions/${id}`);

// Submissions
export const submitAnswer = (questionId, answer) => api.post(`/questions/${questionId}/submit`, { answer });
export const getSubmissions = (questionId, userId) => api.get(`/questions/${questionId}/submissions`, { params: { user_id: userId } });
export const overrideSubmission = (submissionId, data) => api.post(`/submissions/${submissionId}/override`, data);
export const getSubmissionTrace = (submissionId) => api.get(`/submissions/${submissionId}/trace`);

// Documents
export const uploadDocument = (formData) => api.post('/documents/upload', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const getDocuments = (workbookId) => api.get('/documents', { params: { workbook_id: workbookId } });
export const deleteDocument = (id) => api.delete(`/documents/${id}`);

// Final Review
export const generateFinalReview = (workbookId) => api.post(`/workbooks/${workbookId}/final-review`);
export const getFinalReview = (workbookId) => api.get(`/workbooks/${workbookId}/final-review`);

// Coursework sign-off (PR 8a)
export const getCourseworkStatus = () => api.get('/coursework/status');
export const submitCoursework = (declarationConfirmed) =>
  api.post('/coursework/submit', { declaration_confirmed: declarationConfirmed === true });
export const getCourseworkQueue = () => api.get('/admin/coursework');
export const getCourseworkReview = (userId) => api.get(`/admin/coursework/${userId}`);
// PR 8b.1: several assessors share the admin login, so return/approve/revoke
// all carry the person's typed name (required by the backend).
export const returnCoursework = (userId, note, assessorName) =>
  api.post(`/admin/coursework/${userId}/return`, { note, assessor_name: assessorName });
export const approveCoursework = (userId, assessorName) =>
  api.post(`/admin/coursework/${userId}/approve`, { assessor_name: assessorName });
export const revokeCoursework = (userId, reason, assessorName) =>
  api.post(`/admin/coursework/${userId}/revoke`, { reason, assessor_name: assessorName });
export const saveCourseworkFeedback = (userId, feedback) =>
  api.put(`/admin/coursework/${userId}/feedback`, { feedback });
// PR 8b: the evidence pack downloads as an authenticated blob (the cookie
// auth rides along via withCredentials) — never a bare <a href>.
export const downloadEvidencePack = (userId) =>
  api.get(`/admin/coursework/${userId}/evidence-pack`, { responseType: 'blob' });

// Admin
export const getLearners = () => api.get('/admin/learners');
export const getNeedsAttention = () => api.get('/admin/needs-attention');
export const createLearner = (data) => api.post('/admin/learners', data);
export const getLearnerProgress = (userId) => api.get(`/admin/learners/${userId}/progress`);
export const getAdminLearnerQuestionSubmissions = (learnerId, questionId) =>
  api.get(`/admin/learners/${learnerId}/questions/${questionId}/submissions`);
export const deleteLearner = (userId) => api.delete(`/admin/learners/${userId}`);

export default api;
